export default __webpack_public_path__ + "static/media/james.7aa6a1db.jpg";